import { ChildEntity } from '$/entities/BaseEntity';

import { CertnCreditReport as CertnCreditReportCommon } from '$/common/entities/tenantScreening/CertnCreditReport';
export * from '$/common/entities/tenantScreening/CertnCreditReport';

@ChildEntity()
export class CertnCreditReport extends CertnCreditReportCommon {
}
